import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

export interface Options {
  rangeFrom?: string;
  rangeTo?: string;
  adjustDates?: boolean;
  exclusionId?: number;
}

export default (makeCall: MakeCall) => (listingId: number, options?: Options) =>
  makeCall<undefined>('DELETE', `${APIV2_URL}/listing/${listingId}`, {
    query: { ...options },
  });
